import React from "react";
import { Link } from "react-router-dom";
import AppIcons from "../../../assets/images/icons";
// import TeamLogo from "../../../assets/images/icons/teamLogo.svg";

import "./about.scss"
import { ScrollToTopOnMount } from "../../../Components/ScrollToTop/ScrollToTop";
import ContactPopup from "../../../Components/ContactPopup/ContactPopup";
import OurValues from "../../../Components/OurValues/OurValues";
import { Grid } from "@mui/material";
import OurTeam from "../../../Components/ourTeam/ourTeam";



const AboutUs = () => {
  ScrollToTopOnMount();

  return (
    <div className="page-main-wrapper about-main-wrapper about-revamp-wrapper f-wrp">
      <div className="abt-img-wrp f-wrp">
        <span><img src={AppIcons.propWhiteLogo} alt="propshop-logo" /></span>
      </div>
      <div className="container">

        <div className="abt-cont-wrp f-wrp">

          <Grid container spacing={1.5}>
            <Grid item xs={12} sm={12} md={12} lg={10}>
              <div className="abt-section-box f-wrp">
                <h2 className="subtitle">Investment-First Real Estate</h2>
                <p>Propshop is here to transform how you invest in Dubai real estate market, providing expert guidance and exclusive market insights for smart, confident decisions.</p>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={9}>
              <div className="abt-section-box padding-ryt-adjust f-wrp">
                <h1 className="main-title">Get to Know Propshop</h1>
                <p>Founded in 2023 by Sarah Sajwani, Propshop is a real estate agency in Dubai built on a bold vision — to empower individuals, especially women, to confidently navigate the Dubai real estate market. Backed by a team of experienced professionals, we offer expert guidance, exclusive access, and a deep understanding of Dubai’s investment landscape. At Propshop, we believe that with the right support, anyone can build lasting wealth through real estate. Let’s start your Dubai investment journey — together.</p>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={3}>
              <div className="abt-section-box abt-list-box f-wrp">
                <h2 className="subtitle">EXPLORE PROPSHOP</h2>
                <ul className="arrowList">
                  <li className="contact-popup"><ContactPopup title={'Contact us'} defaultComment={"Please call me. I'm interested in..."} /></li>
                  <li><Link to='/blog' >Blogs & Posts</Link></li>
                  <li><Link to='/register' >Become our agent</Link></li>
                </ul>
              </div>
            </Grid>
          </Grid>
        </div>

        <div className='value-main-wrpp our-value-wrp f-wrp'>

          <div className='value-header f-wrp'>
            <h1>The Values</h1>
          </div>
          <OurValues />
        </div>

        {/* <div className='team-section-wrp f-wrp' id="our-team">
          <div className='value-header f-wrp'>
            <h1>Our Team</h1>
          </div>
          <OurTeam />
        </div> */}

      </div>
    </div>
  );
};

export default AboutUs;
